import { TelemetryEvent } from '@ms/oteljs';
import { getAriaEvent } from '@ms/oteljs-aria/dist/src/GetAriaEvent';
import { addOTelColumnDataEventLaunchEvent } from 'owa-addins-analytics';
import { IAutoRunAddinCommand } from 'owa-addins-store';
import { lazyGetOTelAddinsLogger } from 'owa-analytics';
import { ariaTenantToken, nexusTenantToken } from './tokenConstants';

export async function logLaunchEventTelemetry(
    autoRunAddinCommand: IAutoRunAddinCommand,
    hostItemIndex: string,
    controlId: string
): Promise<void> {
    let event: TelemetryEvent = {
        eventName: 'Office.Extensibility.Host.LaunchEvent',
        telemetryProperties: {
            ariaTenantToken: ariaTenantToken,
            nexusTenantToken: nexusTenantToken,
        },
    };
    const logger = await lazyGetOTelAddinsLogger(event.telemetryProperties.ariaTenantToken);
    const ariaEvent = getAriaEvent(event, [], Date.now());
    addOTelColumnDataEventLaunchEvent(ariaEvent, autoRunAddinCommand, hostItemIndex, controlId);
    logger.logEvent(ariaEvent);
}
